export default __webpack_public_path__ + "static/media/brazilIcon.87a5bcd4.svg";